import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { Language } from 'enums/types';
import * as style from './checkbox.module.scss';

interface Props {
	checked: boolean;
	disabled?: boolean;
	children: React.ReactNode;
	isCookieBlock?: boolean;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const Checkbox = ({ checked, disabled, children, isCookieBlock, onChange }: Props) => {
	const { locale } = useIntl();
	return (
		<label className={classnames(
			style.label, {
				[style.cookieCheckbox]: isCookieBlock,
				[style.spanStyleForArabicLang]: locale === Language.Arabic,
				[style.disableCursor]: disabled
			})}>
			<input
				type="checkbox"
				className={style.input}
				checked={checked}
				onChange={onChange}
				disabled={disabled}
			/>
			<span className={classnames(
				style.checkmark, {
					[style.rightAlign]: locale === Language.Arabic,
					[style.grey]: disabled
				})} />
			<span>{children}</span>
		</label>
	);
};

export default Checkbox;
